import { State, Action } from './typings'
import {
  loadRelated,
  applySelection,
  selectServiceLocation,
  selectPrimaryServiceLocation,
  updateServiceLocation,
} from './actions'
import { initialState } from './initialState'

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'clearSelection':
      return initialState

    case 'applySelection':
      return applySelection(state, action.payload)

    case 'loadRelated':
      return loadRelated(state, action.payload)

    case 'selectServiceLocation':
      return selectServiceLocation(state, action.payload)

    case 'selectPrimaryServiceLocation':
      return selectPrimaryServiceLocation(state, action.payload)
    case 'updateServiceLocation':
      return updateServiceLocation(state, action.payload)
  }
}
